import React from "react";

// Customizable Area Start
import { TextField, Button, Box, Typography, Select, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { backgroundImage, logoImage } from "./assets";
import Twemoji from 'react-twemoji';
// Customizable Area End


import EmailAccountLoginController, {
  Props,
} from "./EmailAccountLoginController";

export default class EmailAccountLoginBlock extends EmailAccountLoginController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  render() {
    return (
      <Box sx={{ 
        display: 'flex', 
        minHeight: '100vh',
        width: '100%'
      }}>
        <Box sx={{
          flex: 1,
          padding: '32px 42px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '50%'
        }}>
          <Box sx={{ alignSelf: 'flex-start', marginBottom: '32px', cursor: 'pointer' }}>
            <img
              onClick={() => this.props.navigation.navigate("LandingPage")} 
              src={logoImage} 
              alt="Logo" 
              style={{ width: '148px', height: '24px' }}
            />
          </Box>

          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '340px',
            margin: 'auto',
          }}>



            <Typography 
              variant="h4" 
              sx={{ 
                textAlign: 'center',
                fontSize: '22px',
                fontWeight: 700,
                letterSpacing: '-0.33px',
                color: '#2a1c1c',
                marginBottom: '40px'
              }}
            >
              Log in
            </Typography>           

            {/* Phone Number Field */}
        <Box sx={{ marginBottom: "30px" }}>
          <Typography sx={{ fontWeight: 700, fontSize: "14px", marginBottom: "8px" }}>
            Phone number
          </Typography>
          <Box sx={{ display: "flex", gap: "8px" }}>
            <Select
            data-test-id = "countryCodeSelect"
            value={this.state.countryCodeSelected}
            onChange={this.handleCountryCodeChange}
              defaultValue="DE"
              sx={{
                display: 'flex',
                alignItems: 'center',
                minWidth: "76px",
                height: "44px",
                border: "1px solid #cbd5e1",
                borderRadius: "12px",
                padding: "27px 0",
                backgroundColor: "#fff",
              }}
              IconComponent={KeyboardArrowDownIcon}
              renderValue={(value) => {
                const country = this.state.flagResponse?.response?.find(
                                  (country) => country.id === value
                                );
                                return country ? (
                                  <Twemoji options={{  ext: '.svg',  folder: 'svg',}}>
                                  <span
                                    style={{
                                      marginRight: "50px",
                                      position: "relative",
                                      borderRadius: "0",
                                      fontSize: "28px", 
                                      verticalAlign: 'middle',
                                      lineHeight: 1,                           
                                    }}
                                  >
                                    {country.attributes.emoji_flag}
                                  </span>
                                  </Twemoji>
                                ) : (
                                  value
                                );
              }}
              MenuProps={{
                sx: {
                  '& .MuiMenuItem-root': {
                    width: '130%',
                  },
                },
                anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
                },
                transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
                },
                PaperProps: {
                style: {
                  width: 345,
                  maxHeight: 250,
                  overflow: 'auto',
                },
                },
                }}
            >
              {this.state.flagResponse?.response?.map((country) => (
                <MenuItem value={country.id} key={country.id}  sx={{ alignItems: "center", display: "flex", width: '100%',
                  '& img.emoji': {
                    width: '24px', 
                    height: '24px',
                    },
                 }}>
                  <Twemoji options={{ ext: '.svg',  folder: 'svg', }}>
                  <span style={{ position: "relative",  marginRight: "8px", fontSize: "24px",}}>{country.attributes.emoji_flag}</span>
                  </Twemoji>
                  {country.attributes.name}
                </MenuItem>
              ))}
            </Select>

            <TextField
            data-test-id = "txtInputPhoneNumber"
              value={this.formatPhoneNumber(this.state.phoneNumber)} 
              onChange={this.handlePhoneNumberChange}
              onKeyDown={this.preventInvalidInput} 
              fullWidth
              placeholder="Phone number"
              inputProps={{ maxLength: 12 }} 
              error={!!this.state.phoneError} 
              helperText={this.state.phoneError} 
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: this.state.phoneError ? "red" : "#cbd5e1", 
                    borderRadius: "12px",
                  },
                  
                },
                "& .MuiFormHelperText-root": {
                    marginLeft: "-1",
                    whiteSpace: 'nowrap',
                  },
                height: "44px",
              }}
            />
          </Box>
        </Box>

        <Button
        data-test-id = "btnVerify"
          fullWidth
          variant="contained"
          disabled={!this.state.phoneNumber || !!this.state.phoneError}
          sx={{
            textTransform: 'none',
            backgroundColor: this.state.phoneNumber && !this.state.phoneError ? '#000' : '#f1f5f9',
            color: this.state.phoneNumber && !this.state.phoneError ? '#fff' : '#64748b',
            fontWeight: 700,
            fontSize: '16px',
            padding: '10px 16px',
            marginBottom: '20px',
            borderRadius: '12px',
            '&:hover': {
              backgroundColor: this.state.phoneNumber && !this.state.phoneError ? '#333' : '#e2e8f0',
            }
          }}
          onClick={this.handleVerifyButtonClick}
        >
          Log in
        </Button>

            <Box sx={{ textAlign: 'center' }}>
              <Typography component="span" sx={{ fontSize: '16px' }}>
                Don't have an account?{' '}
              </Typography>
              <Typography
              onClick={() => this.props.navigation.navigate("EmailAccountRegistration")}
                component="span"
                sx={{
                  fontSize: '16px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Sign up
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{
          position: 'relative',
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '50%',
}}>
  <img alt="Background" src={backgroundImage}  style={{ height: '100%', width: '100%',  }} />
  <Box sx={{
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))`
  }} />
</Box>
      </Box>
    );
  }
  // Customizable Area End
}

// Customizable Area Start
const webStyle = {
  // custom style definitions
};
// Customizable Area End
